export default __webpack_public_path__ + "static/media/DingLing.91fb71c3.mp3";